import { PropTypes } from 'prop-types';
import React from 'react';

import StoryShimCursor from './StoryShimCursor';

// Body 01 [Full Text]
// This slide should just have text centered in the middle of the screen
const StoryBody01 = ({ bodyData }) => {
  const { fullText = {} } = bodyData;
  return (
    <div className="story__body01">
      <StoryShimCursor />
      <p className="text">{fullText && fullText.fullText}</p>
    </div>
  );
};

StoryBody01.propTypes = {
  bodyData: PropTypes.object,
};

export default StoryBody01;
